<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      <span class="font-weight-bold">
        Adicionando E-mails
      </span>
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            type="email"
            label="E-mail"
            maxlength="150"
            class="rounded-tag-small"
            v-model="email"
          />
          <div class="pt-1 text-right">
            <v-btn small
              class="normal-btn-text rounded-tag-small elevation-0"
              color="primary"
              :disabled="$v.$invalid || !email"
              @click="addEmail">
              <v-icon small>mdi-plus</v-icon>
              Adicionar e-mail
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card outlined class="rounded-card">
            <v-list>
              <v-list-item dense>
                <v-list-item-title class="text--primary">
                  E-mails
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-for="(item, i) in fornecedor.emails" :key="i">
                <v-list-item-title>
                  {{ item | naoInformado}}
                </v-list-item-title>
                <v-list-item-action>
                  <v-btn icon small @click="remove(item)">
                    <v-icon small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="!fornecedor.emails.length">
                <v-list-item-title>Nenhum e-mail informado</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small"
             :loading="loading"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text elevation-0" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { email } from 'vuelidate/lib/validators';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  props: {
    currentFornecedor: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      email: null,
      fornecedor: {
        emails: [],
      },
    };
  },
  methods: {
    close() {
      this.email = null;
      this.dialog = false;
    },
    remove(item) {
      this.fornecedor.emails = this.fornecedor.emails.filter(mail => mail !== item);
    },
    getEmails() {
      GestaoFornecedorService.get(this.currentFornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedor.emails = fornecedor.emails || [];
        });
    },
    addEmail() {
      if (!(this.fornecedor.emails.includes(this.email))) {
        this.fornecedor.emails.push(this.email);
        this.email = null;
      } else {
        this.$toast('Email já incluso a lista', { color: 'error' });
        this.email = null;
      }
    },
    initialState() {
      this.getEmails();
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedor };
      return fornecedor;
    },
    save() {
      this.loading = true;
      GestaoFornecedorService.updateEmail(this.currentFornecedor.id, this.buildPayload())
        .then(() => {
          this.$emit('update');
          this.$toast('Emails Atualizados', { color: 'success' });
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.initialState();
    },
  },
  validations: {
    email: {
      email,
    },
  },
};
</script>
